import template from './service_assignment_rules.edit.html';
import controller from './service_assignment_rules.edit.controller';
import './service_assignment_rules.edit.scss';

let ServiceAssignmentRulesEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default ServiceAssignmentRulesEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/edit/service_assignment_rules.edit.component.js